<template>
  <b-modal id="page-library-modal" class="page-library-modal" v-on:shown="setup" v-on:hidden="clean">

    <div slot="modal-header" class="container page-library-header">
      <div class="row btn-row">

        <div class="col-12">
          <button type="button"
                  class="btn btn-outline-primary float-right"
                  v-on:click="$root.$emit('hide::modal', 'page-library-modal')">
            {{ $t('common.close') }}
          </button>

          <Tooltip class="float-right"
                    position="bottom"
                    v-bind:show="showTooltip"
                    v-on:tooltip-closed="onTooltipClosed">
            <button type="button"
                    class="btn btn-primary"
                    v-bind:disabled="selectedPageList.length === 0"
                    v-on:click="importPages">
              {{ $t('common.add') }}
            </button>

            <div slot="tooltip-body">
              <div class="typography--body-3 typography--color-secondary"
                   v-html="$t('common.tooltip.try_select_and_add_pages')">
              </div>
            </div>
          </Tooltip>

          <div class="float-right text-right selected-page-count" v-show="selectedPageList.length > 0">
            <small class="typography--caption">{{ $t('page_library.selected_count', { cnt: selectedPageList.length }) }}</small>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12">

          <nav class="navbar navbar-toggleable navbar-light justify-content-center">
            <ul class="nav navbar-nav justify-content-center">
              <li class="nav-item" v-bind:class="isNotQuizTabBindings">
                <a class="nav-link typography--body-3" v-on:click="selectIsQuiz('0')">{{ $t('common.card.non_quiz') }}</a>
              </li>
              <li class="nav-item" v-bind:class="isQuizTabBindings">
                <a class="nav-link typography--body-3" v-on:click="selectIsQuiz('1')">{{ $t('common.card.quiz') }}</a>
              </li>
            </ul>
          </nav>

        </div>
      </div>
    </div>

    <!-- modal body -->
    <div class="container page-library-body mw-960">
      <div class="row browse-filter-row">

        <div class="col-12 col-lg-7">
          <div class="row box">
            <div class="col-sm-3 divider">
              <b-dropdown
                class="mnv-dropdown"
                v-bind:text="getTranslatedName(gradeMap[pageLibraryFilters.grade_id])"
              >
                <b-dropdown-item v-on:click="selectGrade('0', '0')">
                  {{ $t('common.selects.all_grades') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(value, key) in gradeList"
                  v-on:click="selectGrade(value.id, value.school_year)"
                  v-bind:key="key"
                >
                  {{ getTranslatedName(gradeMap[value.id]) }}
                </b-dropdown-item>
                <b-dropdown-item @click="selectGrade('null', 'null')">
                  {{ $t('common.selects.others') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-sm-3 divider">
              <b-dropdown
                id="page-subject-dropdown"
                class="mnv-dropdown"
                v-bind:text="getTranslatedName(subjectMap[pageLibraryFilters.subject_id])"
              >
                <b-dropdown-item v-on:click="selectSubject('0')">
                  {{ $t('common.selects.all_subjects') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(value, key) in gradeSubjects"
                  v-on:click="selectSubject(value.id)"
                  v-bind:key="key"
                >
                  {{ getTranslatedName(subjectMap[value.id]) }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Units -->
            <div class="col-sm-6">
              <b-dropdown v-bind:text="getUnitLabel(units[pageLibraryFilters.unit_id]) || $t('common.browse_filters.all_chapters')" class="mnv-dropdown" id="page-unit-dropdown">
                <b-dropdown-item v-on:click="selectUnit('0')">
                  {{ $t('common.browse_filters.all_chapters') }}
                </b-dropdown-item>

                <b-dropdown-item v-for="unit in currentUnitList"
                                 v-on:click="selectUnit(unit.id)"
                                 v-bind:key="unit.id">
                  {{ getUnitLabel(unit) }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Core Concepts -->
            <!-- <div class="col-sm-6" v-show="getSchoolYear(gradeMap[pageLibraryFilters.grade_id]) >= 7">
              <b-dropdown v-bind:text="getDetailedCoreConceptLabel(coreConcepts[pageLibraryFilters.core_concept_id]) || $t('common.browse_filters.all_core_concepts')" class="mnv-dropdown core-concept-select" id="page-core-concept-dropdown">
                <b-dropdown-item v-on:click="selectCoreConcept('0')">
                  {{ $t('common.browse_filters.all_core_concepts') }}
                </b-dropdown-item>

                <b-dropdown-item v-for="coreConcept in currentCoreConceptList"
                                 v-on:click="selectCoreConcept(coreConcept.id)"
                                 v-bind:key="coreConcept.id"
                                 v-bind:title="`${$t('card_details.card_meta.learning_elements')}: ${coreConcept.description}`">
                  {{ getDetailedCoreConceptLabel(coreConcept) }}
                </b-dropdown-item>
              </b-dropdown>
            </div> -->
          </div>
        </div>

        <div class="col-12 col-lg-5">
          <SearchInput v-bind:model-value="pageLibraryFilters.search_keywords" v-on:input="applySearchKeywords"></SearchInput>
        </div>
      </div>

      <div class="row browse-filter-row">
        <div class="col-sm-8">

          <Radio v-on:change="selectMediaType" v-bind:model-value="pageLibraryFilters.media_type" check-value="all" id="media-type-all">
            <span slot="label">{{ $t('common.browse_filters.media_type.all') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="pageLibraryFilters.media_type" check-value="image" id="media-type-image">
            <span slot="label">{{ $t('common.browse_filters.media_type.image') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="pageLibraryFilters.media_type" check-value="video" id="media-type-video">
            <span slot="label">{{ $t('common.browse_filters.media_type.video') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="pageLibraryFilters.media_type" check-value="audio" id="media-type-audio">
            <span slot="label">{{ $t('common.browse_filters.media_type.audio') }}</span>
          </Radio>

        </div>

        <div class="col-sm-4">
          <ul class="nav justify-content-end order-by-btns">
            <li class="nav-item">
              <a class="nav-link typography--color-secondary"
                 v-bind:class="{ active: pageLibraryFilters.order_by === 'updated_at' }"
                 v-on:click="selectOrderBy('updated_at')">{{ $t('common.browse_filters.order_by.recency') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link typography--color-secondary"
                 v-bind:class="{ active: pageLibraryFilters.order_by === 'popularity' }"
                 v-on:click="selectOrderBy('popularity')">{{ $t('common.browse_filters.order_by.popularity') }}</a>
            </li>
          </ul>
        </div>
      </div>


      <div class="row" v-if="loading">
        <div class="col-12">
          <div class="card-row">
            <DummyPageItem></DummyPageItem>
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12" v-for="(page, index) in storePageList" v-bind:key="page.id">
          <div class="card-row">
            <PageItem v-bind:page="page" v-bind:index="index"></PageItem>
          </div>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-more" class="col-12 text-center mb-5 pb-5">
            <div class="empty-list-text typography--body-2 typography--color-disabled pt-4">
              {{ $t('page_library.no_pages') }}
            </div>
          </div>
        </InfiniteLoading>
      </div>
    </div>

    <div slot="modal-footer"></div>
  </b-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, debounce, isNil } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';
  import labels from '@/mixins/labels';

  export default {
    name: 'page-library-modal',

    components: {
      InfiniteLoading,
    },

    mixins: [
      labels,
    ],

    data() {
      return {
        loading: false,
        isShown: false,
      };
    },

    computed: {
      ...mapGetters([
        'trimmedPageLibraryFilters',
        'pageLibraryFilters',
        'selectedPageList',
        'checkedTutorials',
        'coreConceptList',
        'storePageList',
        'coreConcepts',
        'subjectMap',
        'subjectIds',
        'gradeMap',
        'gradeIds',
        'unitList',
        'units',
        'gradeList',
        'gradeSubjects',
        'currentUser',
      ]),

      showTooltip() {
        if (!isEmpty(this.checkedTutorials) &&
            this.checkedTutorials.tryAddNewPages &&
            !this.checkedTutorials.trySelectAndAddPages) {
          return true;
        }

        return false;
      },

      selectedSubjectGrade() {
        return `${this.pageLibraryFilters.subject_id}&${this.pageLibraryFilters.grade_id}`;
      },

      currentUnitList() {
        return this.unitList.filter(unit => (
          unit.subject_id === parseInt(this.pageLibraryFilters.subject_id, 10) &&
          // unit.grade_id === parseInt(this.pageLibraryFilters.grade_id, 10) &&
          unit.name !== 'NO NAME YET'
        ));
      },

      currentCoreConceptList() {
        return this.coreConceptList.filter(coreConcept => (
          coreConcept.subject_id === parseInt(this.pageLibraryFilters.subject_id, 10) &&
          coreConcept.grade_id === parseInt(this.pageLibraryFilters.grade_id, 10)
        ));
      },

      isQuizTabBindings() {
        return {
          active: this.pageLibraryFilters.is_quiz === '1',
        };
      },

      isNotQuizTabBindings() {
        return {
          active: this.pageLibraryFilters.is_quiz === '0',
        };
      },
    },

    watch: {
      gradeSubjects(state) {
        if (isEmpty(state)) {
          document.getElementById('page-subject-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('page-subject-dropdown').firstElementChild.disabled = false;
        }
      },

      currentCoreConceptList(state) {
        if (isEmpty(state)) {
          document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = false;
        }

        return !isEmpty(state);
      },

      currentUnitList(state) {
        if (isEmpty(state)) {
          document.getElementById('page-unit-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('page-unit-dropdown').firstElementChild.disabled = false;
        }

        return !isEmpty(state);
      },

      selectedSubjectGrade(state) {
        if (state.match(/^[0-9]+&0$/) || state.match(/^0&[0-9]+$/)) {
          return null;
        }

        if (!isNil(state.match(/[0-9]+&[0-9]+/))) {
          // if (this.getSchoolYear(this.gradeMap[this.pageLibraryFilters.grade_id]) > 6) {
          //   if (isEmpty(this.currentCoreConceptList)) {
          //     return this.fetchCoreConcepts({
          //       subject_id: this.pageLibraryFilters.subject_id,
          //       grade_id: this.pageLibraryFilters.grade_id,
          //     });
          //   }

          //   return null;
          // }

          return this.fetchUnits({
            subject_id: this.pageLibraryFilters.subject_id,
            grade_id: this.pageLibraryFilters.grade_id,
          });
        }

        return null;
      },
    },

    methods: {
      ...mapActions([
        'setPageLibraryFilter',
        'setTutorialAsChecked',
        'resetSelectedPage',
        'fetchCoreConcepts',
        'fetchStorePages',
        'fetchUnits',
        'fetchGradeSubjects',
      ]),

      onInfinite() {
        if (this.isShown) {
          this.setPageLibraryFilter({ property: 'offset', value: this.pageLibraryFilters.offset + 20 })
            .then(() => (
              this.fetchStorePages(this.trimmedPageLibraryFilters)
            ))
            .then((pageList) => {
              if (this.$refs.infiniteLoading) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

                if (pageList.length === 0) {
                  this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                }
              }
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectIsQuiz(isQuiz) {
        if (this.pageLibraryFilters.is_quiz !== isQuiz) {
          this.setPageLibraryFilter({ property: 'is_quiz', value: isQuiz })
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;
              document.querySelector('#page-library-modal .modal-body>div').scrollIntoView(true);

              return this.fetchStorePages(this.trimmedPageLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectSubject(subjectId) {
        if (this.pageLibraryFilters.subject_id !== subjectId) {
          this.setPageLibraryFilter({ property: 'subject_id', value: subjectId })
            .then(() => (
              this.setPageLibraryFilter({ property: 'core_concept_id', value: '0' })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'unit_id', value: '0' })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchStorePages(this.trimmedPageLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectGrade(gradeId, schoolYear) {
        if (this.pageLibraryFilters.grade_id !== gradeId) {
          this.fetchGradeSubjects({ grade: schoolYear })
            .then(() => (
              this.setPageLibraryFilter({ property: 'school_year', value: schoolYear })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'grade_id', value: gradeId })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'subject_id', value: '0' })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'core_concept_id', value: '0' })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'unit_id', value: '0' })
            ))
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchStorePages(this.trimmedPageLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectUnit(unitId) {
        if (this.pageLibraryFilters.unit_id !== unitId) {
          this.setPageLibraryFilter({ property: 'unit_id', value: unitId })
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchStorePages(this.trimmedPageLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectCoreConcept(coreConceptId) {
        if (this.pageLibraryFilters.core_concept_id !== coreConceptId) {
          this.setPageLibraryFilter({ property: 'core_concept_id', value: coreConceptId })
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchStorePages(this.trimmedPageLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectMediaType(mediaType) {
        this.setPageLibraryFilter({ property: 'media_type', value: mediaType })
          .then(() => (
            this.setPageLibraryFilter({ property: 'offset', value: 0 })
          ))
          .then(() => {
            this.loading = true;

            return this.fetchStorePages(this.trimmedPageLibraryFilters);
          })
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      selectOrderBy(orderByParam) {
        if (this.pageLibraryFilters.order_by !== orderByParam) {
          this.setPageLibraryFilter({ property: 'order_by', value: orderByParam })
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchStorePages(this.trimmedPageLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      // eslint-disable-next-line func-names
      fetchWithSearchKeywords: debounce(function () {
        this.loading = true;

        this.fetchStorePages(this.trimmedPageLibraryFilters)
          .then(() => {
            this.loading = false;
          });
      }, 500),

      applySearchKeywords(inputText) {
        if (this.pageLibraryFilters.search_keywords !== inputText) {
          this.setPageLibraryFilter({ property: 'search_keywords', value: inputText })
            .then(() => (
              this.setPageLibraryFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.fetchWithSearchKeywords();
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      setup() {
        if (this.storePageList.length === 0) {
          this.loading = true;

          Promise.resolve()
            .then(() => (
              this.setPageLibraryFilter({ property: 'grade_id', value: this.currentUser.grade_id })
            ))
            .then(() => (
              this.fetchGradeSubjects({ grade: this.currentUser.grade_id })
            ))
            .then(() => (
              this.fetchStorePages(this.trimmedPageLibraryFilters)
            ))
            .then(() => {
              this.loading = false;
              this.isShown = true;
            })
            .catch((err) => {
              console.error('err while fetching store pages in page library view:', err);
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        } else {
          this.isShown = true;
        }
      },

      onTooltipClosed() {
        this.setTutorialAsChecked('trySelectAndAddPages');
      },

      importPages() {
        if (!isEmpty(this.checkedTutorials) &&
            !this.checkedTutorials.trySelectAndAddPages) {
          this.setTutorialAsChecked('trySelectAndAddPages')
            .then(() => {
              this.$emit('import-pages', this.selectedPageList);
              this.$root.$emit('hide::modal', 'page-library-modal');
            });
        } else {
          this.$emit('import-pages', this.selectedPageList);
          this.$root.$emit('hide::modal', 'page-library-modal');
        }
      },

      clean() {
        this.resetSelectedPage();
        document.querySelector('#page-library-modal .modal-body>div').scrollIntoView(true);
        this.isShown = false;
      },
    },

    mounted() {
      if (isEmpty(this.gradeSubjects)) {
        document.getElementById('page-subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('page-subject-dropdown').firstElementChild.disabled = false;
      }

      if (isEmpty(this.currentCoreConceptList)) {
        document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = false;
      }

      if (isEmpty(this.currentUnitList)) {
        document.getElementById('page-unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('page-unit-dropdown').firstElementChild.disabled = false;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/PageLibraryModal.vue